import React from 'react';

function NetworkWrapper(props) {
    if(props.isLoading) {
        return (
            <div>
                <h1>
                    Loading...
                </h1>
            </div>
        );
    }

    if(props.error) {
        return (
            <div>
                <h1>Error...</h1>
                <div>
                    {props.error}
                </div>
            </div>
        );
    }

    return (
        <>
            {props.children}
        </>
    );
}

export default NetworkWrapper;